import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe} from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HttpClientModule } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { MatInputModule } from '@angular/material/input';
import { BroadcastService } from './services/broadcast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PrivilegesGuard } from './privileges/privileges.guard';
import { MatDialogModule } from '@angular/material/dialog';
import { TranscodingAddProfilesComponent } from './components/transcoding/transcoding-add-profiles/transcoding-add-profiles.component';
import * as $ from 'jquery';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { PrivilagesComponent } from './components/administration/privilages/privilages.component';





//RAM import { CatalogsComponent } from './components/catalogs/catalogs.component';

@NgModule({
  //RAM declarations: [AppComponent, CatalogsComponent],
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxSpinnerModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    
    // Vex
    VexModule,
    CustomLayoutModule,
    MatInputModule,
    MatDialogModule
  ],
  providers: [
    DatePipe,
    BroadcastService,
    MatSnackBar,
    PrivilegesGuard,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
